<!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
<!-- eslint-disable @angular-eslint/template/click-events-have-key-events -->
<rx-split-view>
  <div left class="flex">
    <div class="flex flex-nosize">
      <rx-tabs [selected]="0">
        <rx-tab>Original Forms</rx-tab>
      </rx-tabs>
    </div>
    <div class="flex">
      <ul class="flex">
        <li class="flex flex-row" *ngFor="let file of getOriginalForms(template$ | async); let i = index">
          <div class="title">
            <a [href]="file.content" target="blank">{{ i + 1 }} file</a>
          </div>
          <div (click)="remove(file)">
            <rx-icon class="red" name="icon-cross-circle"></rx-icon>
          </div>
        </li>
      </ul>
    </div>
    <div class="flex flex-nosize">
      <input type="file" (change)="uploadOriginalForm($event)" name="file1" id="file1" class="inputfile" multiple />
      <label for="file1">Attach file</label>
    </div>
  </div>
  <div right class="flex">
    <div class="flex flex-nosize">
      <rx-tabs [selected]="0">
        <rx-tab>Built Forms</rx-tab>
      </rx-tabs>
    </div>
    <div class="flex">
      <ul>
        <li class="flex flex-row" *ngFor="let file of getBuiltForms(template$ | async); let i = index">
          <div class="title">
            <a [href]="file.content" target="blank">{{ i + 1 }} file</a>
          </div>
          <div (click)="remove(file)">
            <rx-icon class="red" name="icon-cross-circle"></rx-icon>
          </div>
        </li>
      </ul>
    </div>
    <div class="flex flex-nosize">
      <input type="file" (change)="uploadBuiltForm($event)" name="file2" id="file2" class="inputfile" multiple />
      <label for="file2">Attach file</label>
    </div>
  </div>
</rx-split-view>
